import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import PassportLockup from '../../ShowPage/components/PassportLockup';

function Hero() {
  const HeroBlock = styled.div`
    background: url('/content/themes/tpt/dist/images/passport/hero.jpg');
    background-size: cover;
    background-position: top center;
    max-height: 650px;
    height: 80vh;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-top: -3vw;
    margin-bottom: 2rem;
  `;

  const H1 = styled.h1`
    color:white;
    font-size:3.4rem;
    line-height:1.1;
  `;

  return (
    <HeroBlock>
      <div css={css`color:white;margin-top:20vh;width:100%;padding:40px;`}>
        <H1>
          <PassportLockup maxWidth={367} />
        </H1>
        <p css={css`font-size: 2rem;line-height:1.1;`}>Extended access to 1,500+ episodes</p>
      </div>
    </HeroBlock>
  );
}

export default Hero;

